import { MarketProgram } from '@/features/bidding/constants'
import type {
  AggregateSuggestedBid,
  AggregateSuggestedBidResponse,
} from '@/features/bidding/types/aggregateSuggestedBid'
import type { MarketDate } from '@/features/bidding/utils/date/marketDate'
import { ptusBetweenDates } from '@/features/bidding/utils/date/ptusBetweenDates'

// MW values per hour (0–23), range 3–50
// UP and DOWN share similar values in some stretches but diverge in others
// prettier-ignore
const FCRD_UP_MW =   [ 7, 22, 41, 15, 18, 36, 38, 35, 29, 50,  6, 38, 19, 20, 22, 25, 33, 46, 14,  5, 42, 21, 50, 12 ]
// prettier-ignore
const FCRD_DOWN_MW = [ 34, 8, 25, 47, 20, 34, 40, 33, 31, 48, 43,  5, 31, 18, 24, 23,  7, 37, 50, 18, 30, 44,  9, 26 ]
// prettier-ignore
const FCRN_MW =      [ 19, 45,  6, 33, 50, 14, 27,  3, 42, 17, 35, 48,  8, 24, 50, 11, 40,  5, 30, 47, 13, 38, 23,  7 ]

function buildSuggestionFromValues(
  deliveryDay: MarketDate,
  marketProgram: MarketProgram,
  aggregateKey: string,
  mwValues: number[],
): AggregateSuggestedBid {
  const startOfDay = deliveryDay.getStartOfDay()
  const endOfDay = deliveryDay.plus({ days: 1 }).getStartOfDay()
  const hours = ptusBetweenDates(startOfDay, endOfDay)

  return {
    aggregateKey,
    marketProgram,
    ptus: hours.slice(0, -1).map((start, index) => ({
      ptu: {
        start: start.toISO()!,
        end: start.plus({ hour: 1 }).toISO()!,
      },
      volume: {
        quantity: (mwValues[index] ?? 10) * 1_000_000,
        unit: 'WATTS',
      },
    })),
  }
}

export function buildAggregateSuggestedBidsFcrdResponse(deliveryDay: MarketDate): AggregateSuggestedBidResponse {
  return {
    aggregationLevel: 'PRICE_AREA',
    suggestions: [
      buildSuggestionFromValues(deliveryDay, MarketProgram.NORDICS_FCRD_UP_DYNAMIC, 'FI', FCRD_UP_MW),
      buildSuggestionFromValues(deliveryDay, MarketProgram.NORDICS_FCRD_DOWN_DYNAMIC, 'FI', FCRD_DOWN_MW),
    ],
  }
}

export function buildAggregateSuggestedBidsFcrnResponse(deliveryDay: MarketDate): AggregateSuggestedBidResponse {
  return {
    aggregationLevel: 'PRICE_AREA',
    suggestions: [buildSuggestionFromValues(deliveryDay, MarketProgram.NORDICS_FCRN, 'FI', FCRN_MW)],
  }
}

export function buildAggregateSuggestedBidsResponse(deliveryDay: MarketDate): AggregateSuggestedBidResponse {
  return buildAggregateSuggestedBidsFcrdResponse(deliveryDay)
}
